<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState({
      accessToken: (state) => state.auth.accessToken,
    }),
  },
  mounted() {
    this.$store.dispatch('app/getConfigs')
  },
}
</script>
<style lang="scss">
.el-pagination {
  padding: 1.5em 0;
  float: right;
}

.el-tiptap-editor__content .ProseMirror {
  height: 100% !important;
}
.el-pagination {
  margin-top: 20px;
  margin-bottom: 40px;
}
</style>
